import { TreeDataNode } from 'antd';

export const generateList = (data: TreeDataNode[]): { key: React.Key; label: string }[] => {
  const result: { key: React.Key; label: string }[] = [];
  const traverse = (nodes: TreeDataNode[]): void => {
    for (let i = 0; i < nodes.length; i += 1) {
      const node = nodes[i];
      result.push({ key: node.key, label: node.title as string });
      if (node.children) {
        traverse(node.children);
      }
    }
  };
  traverse(data);
  return result;
};
